// @flow

import { Map } from 'immutable';
import {
  LOAD_MODELS_DETAILS_SUCCESS,
  LOAD_MODELS_DETAILS_FAIL,
  SET_SELECTED_MODEL_INDEX,
  SELECTED_MODEL_INDEX,
  MODELS_DETAILS,
  DELETE_MODEL_SUCCESS,
  DELETE_MODEL_FAIL,
  ERROR,
  CLEAR_ERROR,
} from './../types/model';

import {
  SIGN_OUT,
} from './../types/auth';

import type { ModelAction } from './../actions/model';

const INITIAL_MAP = Map({
  [MODELS_DETAILS]: [],
  [SELECTED_MODEL_INDEX]: 0,
  [ERROR]: "",
});

const modelReducer = (state: Map<string, any> = INITIAL_MAP, action: ModelAction) => {
  switch (action.type) {
    case LOAD_MODELS_DETAILS_SUCCESS:
      if (action[MODELS_DETAILS].length === 0)
        return state
          .set(MODELS_DETAILS, action[MODELS_DETAILS])
      return state
        .set(MODELS_DETAILS, action[MODELS_DETAILS])

    case LOAD_MODELS_DETAILS_FAIL:
      return state
        .set(MODELS_DETAILS, null)
        .set(ERROR, 'Error occured while loading model details');

    case SET_SELECTED_MODEL_INDEX:
      return state
        .set(SELECTED_MODEL_INDEX, action.index)

    case DELETE_MODEL_SUCCESS:
      const currentIndex = state.get(SELECTED_MODEL_INDEX);
      const newCurrentIndex = currentIndex === 0 ? 0 : currentIndex - 1;
      const filteredModelsDetails = state.get(MODELS_DETAILS).filter((modelDetails) => {
        return modelDetails.id !== action.modelId;
      })
      return state 
        .set(MODELS_DETAILS, filteredModelsDetails)
        .set(SELECTED_MODEL_INDEX, newCurrentIndex);

    case DELETE_MODEL_FAIL:
      return state.set(ERROR, 'Error occured while deleting model');

    case CLEAR_ERROR:
      return state.set(ERROR, '');

    case SIGN_OUT:
      return INITIAL_MAP;

    default:
      return state;
  }
};

export default modelReducer;


// WEBPACK FOOTER //
// ./src/reducers/model.jsx